export default "__VITE_ASSET__BpKOJc0M__"